export default __webpack_public_path__ + "static/media/search-by-algolia-light-background.155bab77.svg";